import { PlinkoTemplate } from '@/components/templates/Plinko/templates/PlinkoTemplate'
import { useAppModal, AppModals } from '@/context/ModalProvider'
import { useMaintenance } from '@/hooks/useMaintenance'
import { useEffect } from 'react'

const PlinkoPage = () => {
  const { isMaintenance } = useMaintenance()
  const modal = useAppModal()

  useEffect(() => {
    if (isMaintenance) {
      modal.openModalNew(AppModals.MaintenanceModal)
    }
  }, [])

  return <PlinkoTemplate />
}

export default PlinkoPage
